import _ from 'lodash'

export const progress = state => key => {
    return _.get(state.progress, key, false)
}

export const availableFertilizationMethodsByValue = state => {
    return _.keyBy(state.availableFertilizationMethods, 'value')
}

export const availableReportStatusesByValue = state => {
    return _.keyBy(state.availableReportStatuses, 'value')
}

export const reportSampleTemplatesById = state => {
    return _.keyBy(state.reportSampleTemplates, 'id')
}